import { ActivityType } from '../../UserActivityTypes';

export const activityTypeOptions = [
  { value: ActivityType.DeliveryOfPlan, label: 'Delivery of Plan' },
  { value: ActivityType.OtherActivity, label: 'Other Activity' },
];

export const MAX_ACTIVITY_NAME_CHARS = 200;
export const MAX_COMMENT_CHARS = 2500;
